import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./NewNavBar.css";
import environment from "../../environment/environment.js";

const NewNavBar = () => {
    const [hoveredItem, setHoveredItem] = useState(null);
    const [tripTypeDetails, setTripTypeDetails] = useState({
        internationalList: [],
        domesticList: [],
        weekendList: [],
        groupList: [],
        honeymoonList: [],
    });

    useEffect(() => {
        getAllTripType();
    }, []);

    const handleMouseEnter = (index) => {
        setHoveredItem(index);
    };

    const handleMouseLeave = () => {
        setHoveredItem(null);
    };

    const getAllTripType = () => {
        axios({
            url: `${environment.config.apiBaseUrl}route/getAllTripType`,
            method: "GET",
            headers: {
                authorization: "your token comes here",
            },
        })
            .then((res) => {
                if (res && res.data) {
                    setTripTypeDetails(res.data);
                }
            })
            .catch((err) => {
                console.error("Error fetching trip types:", err);
            });
    };

    const organizeRoutesByName = (routeList) => {
        if (!routeList || routeList.length === 0) return [[], [], []];
        const uniqueRoutes = [];
        const seenNames = new Set();

        routeList.forEach((route) => {
            if (!seenNames.has(route.routeName)) {
                seenNames.add(route.routeName);
                uniqueRoutes.push({
                    name: route.routeName,
                    id: route.routeId,
                });
            }
        });

        const columns = [[], [], []];
        uniqueRoutes.forEach((route, index) => {
            columns[index % 3].push(route);
        });
        return columns;
    };

    const navItems = [
        {
            label: "Group Trips",
            options:
                tripTypeDetails.groupList?.length > 0
                    ? organizeRoutesByName(tripTypeDetails.groupList)
                    : [[{ name: "No packages available", id: null }]],
            key: "group",
        },
        {
            label: "Domestic Packages",
            options:
                tripTypeDetails.domesticList?.length > 0
                    ? organizeRoutesByName(tripTypeDetails.domesticList)
                    : [[{ name: "No packages available", id: null }]],
            key: "domestic",
        },
        {
            label: "Couple Special",
            options:
                tripTypeDetails.honeymoonList?.length > 0
                    ? organizeRoutesByName(tripTypeDetails.honeymoonList)
                    : [[{ name: "No packages available", id: null }]],
            key: "honeymoon",
        },
        {
            label: "International Packages",
            options:
                tripTypeDetails.internationalList?.length > 0
                    ? organizeRoutesByName(tripTypeDetails.internationalList)
                    : [[{ name: "No packages available", id: null }]],
            key: "international",
        },
        {
            label: "Customized Trips",
            options:
                tripTypeDetails.weekendList?.length > 0
                    ? organizeRoutesByName(tripTypeDetails.weekendList)
                    : [[{ name: "No packages available", id: null }]],
            key: "weekend",
        },
    ];

    return (
        <div className="container-fluid newnavbar-container-fluid w-100">
            <div className="container navbarcontainer">
                <nav className="navbars">
                    {navItems.map((item, index) => (
                        <div
                            key={index}
                            className="nav-item"
                            onMouseEnter={() => handleMouseEnter(index)}
                            onMouseLeave={handleMouseLeave}
                        >
                            {item.key === "honeymoon" && (
                                <span className="heart-animation">💖</span>
                            )}
                            {item.label}
                            <span
                                className={`arrow ${hoveredItem === index ? "rotate" : ""
                                    }`}
                            >
                                <i className="bi bi-chevron-down"></i>
                            </span>
                            <div
                                className={`dropdown ${hoveredItem === index ? "show" : ""
                                    } ${index >= navItems.length - 2
                                        ? "dropdown-left"
                                        : ""
                                    }`}
                            >
                                {item.options.map((col, i) => (
                                    <div key={i}>
                                        {col.map((route, j) =>
                                            route.id ? (
                                                <Link
                                                    key={j}
                                                    style={{
                                                        color: "black",
                                                        textDecoration: "none",
                                                        fontWeight: 400,
                                                        fontFamily: 'Roboto, "Roboto Fallback", sans-serif'
                                                    }}
                                                    to={`/tour/${route.id}`}
                                                    target="_blank"
                                                >
                                                    <p>{route.name}</p>
                                                </Link>
                                            ) : (
                                                <p key={j}>{route.name}</p>
                                            )
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                    <div className="nav-item">
                        <Link
                            to="/explore-all"
                            style={{
                                color: "black",
                                textDecoration: "none",
                                fontWeight: 400,
                                fontFamily: 'Roboto, "Roboto Fallback", sans-serif'
                            }}
                        >
                            Explore All
                        </Link>
                    </div>
                </nav>
            </div>
        </div>
    );
};

export default NewNavBar;
